import React, { useEffect, useMemo, useState } from "react";
import styles from '../styles/messageList.module.scss'
import { useMessageContext } from "../context";
import { useGetSiteLetterList, useGetUnreadForType, useRead } from "../hooks/useMessageCenter";
import Icon from "@/wmCompoments/Icon";
import PaginationTo from "@/views/betOrderRecords/compoments/paginationTo";
import LoadingUI from "@/compoments/loadingUI";
import Toast from "@/wmCompoments/toast";
import { divide } from "lodash";
import { useTranslation } from "react-i18next";

const MessageList =() => {
  const { t } = useTranslation('messageCenter')

  // 获取当前上下文中的通用数据和方法
  const { selectedItem, setCurrentMessage, setShowPanel, setMutateList, editor, setList, selectedIds, setSelectedIds
   } = useMessageContext();
  // 页数状态管理
  const [pageNum, setPageNum] = useState(1);
  const pageSize = 10;
  // 请求站内信列表参数
  const params = useMemo(() => {
    return { ...selectedItem, userSystem: '1', pageNum, pageSize };
  }, [selectedItem, pageNum]);
  // 请求站内信列表数据
  const { list, total, isLoading, mutate: mutateList } = useGetSiteLetterList(params)
  // 读取站内信 
  const { trigger, isMutating } = useRead()
  // 获取站内信未读数
  const { mutate } = useGetUnreadForType()
  // 当 selectedItem 改变时，重置页码为第一页
  useEffect(() => {
    setPageNum(1);
  }, [selectedItem]);

  // 将 mutateList 封装(重新请求站内信列表数据)，并注入上下文
  useEffect(() => {
    setMutateList(() => () => mutateList());
  }, [mutateList, setMutateList]);

  // 更新全局站内信列表数据 list
  useEffect(() => {
    setList(prev => {
      const prevIds = prev?.map(i => i?.id).join(',') || '';
      const newIds = list?.map(i => i?.id).join(',') || '';

      if (prevIds !== newIds) {
        return list || [];
      }
      return prev; // 不变则不更新，避免死循环
    });
  }, [list, setList]);

  // 勾选逻辑 (选中消息的ID组成数组)
  const toggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  return (
    <div className={styles.messageList}>
      <LoadingUI loading={isLoading} data={list} >
        {list?.map((v,index)=>{

          const isSelected = selectedIds.includes(v.id); // 当前是否被选中

          return (
          <div className={styles.item} key={index}
            onClick={async () => {
              // 编辑状态下切换选中状态
              if (editor) {
                toggleSelect(v.id); 
                return;
              }
              // 正常模式下进入详情
              if (isMutating) {
                Toast.show(t('tooManyRequests'))
                return
              }
              if(v.isRead !== 1) {
                await trigger({
                  brType: selectedItem?.brType,
                  msgType: selectedItem?.msgType,
                  id: v?.id,
                  userSystem: '1'
                })
                await Promise.all([mutateList(), mutate()])
              }
              setCurrentMessage(v);
              setShowPanel(true);
            }}
          >
            {editor && <div>
              <Icon name="icon-message-choose" 
                className={`${styles.iconWrapper} ${isSelected ? styles.selected : ''}`}
              />
            </div>}

            <div className={styles.icon}>
              <Icon name="icon-message-notice" />
              {v?.isRead !== 1 && <div className={styles.red}></div>} 
            </div>

            <div className={styles.text}>
              <div className={styles.title}>{v.title}</div>
              <div className={styles.content}>{v.content}</div>
            </div>

            <div className={styles.time}>{v?.sendTime}</div>
          </div>
        )})}
      </LoadingUI>

      {/* 分页器 */}
      {total > 0 && <div className={styles.paginationTo}>
        <PaginationTo 
          current={pageNum}
          total={total}
          pageSize={pageSize}
          onChange={(page) => setPageNum(page)}
        />
      </div>}
        
    </div>
  )
}

export default  MessageList